<template>
  <div class="systemStatus">
    <div class="statusItem status--error" v-if="deviceStatus === SYSTEM_STATUS.ERROR">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
          <circle cx="8" cy="8" r="7" stroke="#EF2C2C" stroke-width="2" />
          <circle cx="8" cy="8" r="5" fill="#EF2C2C" />
        </g>
      </svg>
      <span>{{ $t('Web.System.BatteryState.Error') }}</span>
    </div>

    <div class="statusItem status--offline" v-if="deviceStatus === SYSTEM_STATUS.OFFLINE">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
          <circle cx="8" cy="8" r="7" stroke="#F67423" stroke-width="2" />
          <circle cx="8" cy="8" r="5" fill="#F57423" />
        </g>
      </svg>
      <span>{{ $t('Web.System.BatteryState.Problem') }}</span>
    </div>

    <div class="statusItem status--ok" v-if="deviceStatus === SYSTEM_STATUS.ONLINE">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
          <circle cx="8" cy="8" r="7" stroke="#2CEF55" stroke-width="2" />
          <circle cx="8" cy="8" r="5" fill="#2CEF55" />
        </g>
      </svg>
      <span>{{ $t('Web.System.BatteryState.Ok') }}</span>
    </div>
  </div>
</template>

<script>
import ErrorOfflineHandler from '../../helpers/mixins/overviewErrorOfflineHandler';

export default {
  name: 'SystemStatus',
  mixins: [ErrorOfflineHandler],
  props: {
    deviceData: {
      type: Object,
      default: () => {}
    },
    heartbeat: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      SYSTEM_STATUS: Object.freeze({
        ERROR: Symbol('error'),
        OFFLINE: Symbol('offline'),
        ONLINE: Symbol('online')
      })
    };
  },
  computed: {
    /**
     * Check for device errors
     * UPDATE 08/10/2020
     * Device State Error is show when have error at System, Battery or Inverter
     */
    hasErrors() {
      return (
        this.systemStatusCode != 0 ||
        this.systemBatteryError !== 0 ||
        this.systemInverterError !== 0
      );
    },
    isOffline() {
      return this.deviceIsOffline(this.heartbeat);
    },
    systemStatusCode() {
      return ((this.deviceData || {}).parameters || {}).System_SM_Status;
    },
    systemBatteryError() {
      return ((this.deviceData || {}).parameters || {}).System_SM_Battery_Error;
    },
    systemInverterError() {
      return ((this.deviceData || {}).parameters || {}).System_SM_Inverter_Error;
    },
    deviceStatus() {
      if (this.isOffline) {
        this.$emit('systemStatus', 'offline');
        return this.SYSTEM_STATUS.OFFLINE;
      } else if (this.hasErrors) {
        this.$emit('systemStatus', 'error');
        return this.SYSTEM_STATUS.ERROR;
      } else {
        this.$emit('systemStatus', 'online');
        return this.SYSTEM_STATUS.ONLINE;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.systemStatus {
  width: 188px;
  height: 38px;
  border-radius: 48px;
  background-color: $white;
  border: solid 1px $greeny-blue;
  text-align: center;

  svg {
    position: relative;
    top: 3px;
  }

  span {
    @include textSmall;
    line-height: 38px;
    text-align: left;
    color: $charcoal-grey;
    padding-left: 4px;
  }
}
</style>
